import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from "../components/Homepage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Introduction`}</h2>
    <PageDescription mdxType="PageDescription">
Climate change poses one of the most pervasive risks to our planet.
Society needs to be better prepared for natural catastrophes.
At Swiss Re, we make the world more resilient, helping communities and businesses to prepare for and mitigate the consequences of disasters.
We innovate with new solutions and utilise emerging tech to identify and prevent the toughest risks across the globe.
In this challenge, we focus on leveraging Extended Reality technologies such as Virtual, Augmented or Mixed Reality.
The aim is to raise awareness and increase resilience for natural catastrophes such as floods.
The solution can contain but is not limited to simulations of flood scenarios from indoor point of view
and/or on existing facilities.
You can decide to work with the latest Mixed Reality hardware or utilise smartphones;
augment existing Swiss Re solutions or work on your own idea that is related to the challenge.
Our engineers and our challenge partner Microsoft will coach you in this journey.
    </PageDescription>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      